module.exports = __webpack_public_path__ + "img/33-NWQ.fe32f46.png";